import React from 'react';
import ReactSelect from 'react-select';

const Select = (props: any) => {
  if (props.allowSelectAll) {
    const selectAll = {
      ...props.allOption,
      label: props.selectAllLabel,
    };

    return (
      <ReactSelect
        {...props}
        options={[selectAll, ...props.options]}
        onChange={(selected: any, event) => {
          if (selected !== null && selected.length > 0) {
            if (selected[selected.length - 1].value === props.allOption.value) {
              return props.onChange([props.allOption, ...props.options]);
            }
            let result = [];
            if (selected.length === props.options.length) {
              if (selected.includes(props.allOption)) {
                result = selected.filter(
                  (option: any) => option.value !== props.allOption.value,
                );
              } else if (event.action === 'select-option') {
                result = [props.allOption, ...props.options];
              }
              return props.onChange(result);
            }
          }
          return props.onChange(selected);
        }}
      />
    );
  }

  return <ReactSelect {...props} />;
};

Select.defaultProps = {
  allOption: {
    label: 'Select all',
    value: '*',
  },
};

export type SelectProps = {
  options: Array<any>;
  selected: Array<any>;
  value: any;
  onChange: (selected: any, event: any) => void;
  allowSelectAll: boolean;
  allOption: {
    label: string;
    value: string;
  };
  selectAllLabel: string;
};

export default Select;
